export default __webpack_public_path__ + "static/media/d8d64ad95f5675dc18d98d37f72c5d121579724514548.cf342070.webp";